import { render, staticRenderFns } from "./ManageQuizDetail.vue?vue&type=template&id=d31c2b4c&"
import script from "./ManageQuizDetail.vue?vue&type=script&lang=js&"
export * from "./ManageQuizDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManageQuizDetail.vue?vue&type=style&index=0&id=d31c2b4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports